"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _orgGroup = require("@/api/auth/orgGroup");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 水波纹指令
var _default = exports.default = {
  name: 'authDialog',
  directives: {
    waves: _waves.default
  },
  props: ["authData"],
  data: function data() {
    return {
      loading: false,
      resTree: null,
      //资源树
      activeName: 'orgGroupRes',
      defaultProps: {
        label: "name",
        children: "children"
      },
      systemFlag: null
    };
  },
  created: function created() {
    this.orgGroupResTree();
  },
  methods: {
    handleClick: function handleClick() {
      //切换tab
    },
    orgGroupResTree: function orgGroupResTree() {
      var _this = this;
      //资源树
      var query = {
        orgGroupId: this.authData.currOrgGroupId
      };
      (0, _orgGroup.getOrgGroupResTree)(query).then(function (response) {
        _this.resTree = response.data.list;
        _this.systemFlag = response.data.system;
        //获取button是否选中
        if (response.data.selectedList != null && response.data.selectedList.length > 0) {
          _this.$refs.resTree.setCheckedKeys(response.data.selectedList);
        }
      });
    },
    handleOrgGroupResSave: function handleOrgGroupResSave() {
      var _this2 = this;
      this.loading = true;
      //保存组织角色 对应 的资源
      var checkedKeys = this.$refs.resTree.getCheckedKeys(false).concat(this.$refs.resTree.getHalfCheckedKeys());
      var orgGroupResData = {
        orgGroupId: this.authData.currOrgGroupId,
        resIdSet: checkedKeys
      };
      console.log(orgGroupResData);
      (0, _orgGroup.saveOrgGroupRes)(orgGroupResData).then(function () {
        _this2.authData.visible = false;
        // 成功   更新成功
        _this2.$notify({
          title: _this2.$t('prompts.success'),
          message: _this2.$t('prompts.SuccUpdate'),
          type: 'success',
          duration: 3000
        });
        //重新加载
        _this2.$emit('refresh');
        _this2.loading = false;
      }, function () {
        _this2.loading = false;
      });
    }
  }
};